import services from "@src/Services";
import { getCustomExtraPathDashboard } from "../../helper";

export const updateAllNotificationRead = async (filters: FilterType) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathDashboard({ ...filters });

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.patch(
      `/mark-all-notification-as-read${customPath}`,
      {}
    );

    if (res.success) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return { error: err?.error?.message || "Something went wrong!" };
  }
};
